<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { handleNext } from '../tutorialSteps'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_military_ships')
}

const isOnCommandSection = computed(() => {
  return route.path.startsWith('/command/ships')
})

const goToCommand = () => {
  router.push('/command/ships')
}

</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/military.webm"
  >
    <template #text>
      <p class="pb-2">
        {{ t('tutorial.ships.examineScreen') }}
      </p>
      <p class="pb-2 hidden md:flex">
        {{ t('tutorial.ships.splitDesktop') }}
      </p>
      <p class="pb-2 md:hidden">
        {{ t('tutorial.ships.splitMobile') }}
      </p>
      <p class="pb-3">
        {{ t('tutorial.ships.eachShipStats') }}
      </p>
      <div class="grid grid-cols-2 gap-2 pb-3">
        <div class="flex items-center">
          <GenericIcon type="attack_against_ships" class="mr-1"/> {{ t('tutorial.ships.attackVsShips') }}
        </div>
        <div class="flex items-center">
          <GenericIcon type="attack_against_planets" class="mr-1"/> {{ t('tutorial.ships.attackVsPlanets') }}
        </div>
        <div class="flex items-center">
          <GenericIcon type="shields" class="mr-1"/> {{ t('tutorial.ships.shields') }}
        </div>
        <div class="flex items-center">
          <GenericIcon type="max_speed" class="mr-1"/> {{ t('tutorial.ships.maxSpeed') }}
        </div>
        <div class="flex items-center">
          <GenericIcon type="scanning_range" class="mr-1"/> {{ t('tutorial.ships.scanningRange') }}
        </div>
        <div class="flex items-center">
          <GenericIcon type="repair" class="mr-1"/> {{ t('tutorial.ships.repair') }}
        </div>
      </div>
      <p class="pb-2">
        <i18n-t keypath="tutorial.ships.actionChain" tag="span">
          <template #cogIcon><GenericIcon type="cog"/></template>
        </i18n-t>
      </p>
    </template>

    <template #alerts>

    </template>

    <template #buttons>
      <ActionButton v-if="!isOnCommandSection" @click="goToCommand" class="mr-2">
        {{ t('tutorial.ships.goToCommand') }}
      </ActionButton>
      <ActionButton @click="handleNextStep">
        {{ t('tutorial.ships.continue') }}
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss"></style>